module.exports = __webpack_public_path__ + "img/dribble.556b0cce.png";